/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDnb = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5 16.237c.097-.393.173-.793.296-1.178a4.726 4.726 0 0 1 1.235-1.96c.485-.473.98-.934 1.493-1.423l1.287 1.36c-.455.49-.88.98-1.34 1.434-1.272 1.257-1.313 3.139-.081 4.52 1.095 1.23 3.022 1.38 4.328.278.818-.69 1.564-1.466 2.361-2.222-.84-.86-1.653-1.692-2.467-2.523-1.98-2.021-3.957-4.044-5.944-6.057-.213-.217-.311-.43-.304-.738.02-.8.007-1.601.007-2.516l13.682 14.17-1.393 1.319-2.223-2.193c-.733.703-1.425 1.42-2.178 2.066-.469.402-.991.792-1.557 1.02-3.41 1.384-6.804-.979-7.142-4.024-.007-.061-.04-.12-.06-.18v-1.153zm14.826-3.074c-.125.465-.218.942-.384 1.393-.282.768-.761 1.409-1.404 1.968l-1.336-1.397c.072-.08.123-.155.189-.211 1.513-1.325 1.286-4.032-.796-5.201-.214-.12-.28-.237-.274-.469.015-.575.005-1.15.005-1.73 1.735.297 3.432 1.974 3.848 3.787.054.235.101.472.152.707zm-7.598-2.671-1.356-1.426c.327-.304.638-.585.94-.874.698-.667.968-1.474.68-2.405-.286-.922-.904-1.532-1.878-1.715-.724-.136-1.369.073-1.928.532-.375.308-.723.647-1.028.922L6.213 4.278c1.821-2.461 4.472-2.91 6.528-1.432 2.208 1.589 2.42 4.882.45 6.748-.306.29-.617.575-.964.897z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDnb as Dnb };
